<template>
  <ExtracadabraModal
    v-model:opened="internalOpen"
    :header="{
      title: $t('ETAB.PAGES.RECRUITMENT.CANCEL_AE_HELPER.@TITLE'),
    }"
    :card="{ class: 'cancel-ae-helper-modal' }"
    :body="{ class: 'text-center' }"
    size="sm"
  >
    <template #header>
      {{ $t("ETAB.PAGES.RECRUITMENT.CANCEL_AE_HELPER.@TITLE") }}
    </template>
    <template #body>
      <p>{{ $t("ETAB.PAGES.RECRUITMENT.CANCEL_AE_HELPER.@CONTENT") }}</p>
      <img :src="require('@etab/assets/img/cancel_ae_helper.jpg')" alt="tutorial-ae" :draggable="false" />
    </template>
    <template #footer>
      <QBtn v-close-popup class="full-width btn-navigation" color="secondary" :label="$t('ETAB.PAGES.RECRUITMENT.CANCEL_AE_HELPER.@OK')" no-caps />
    </template>
  </ExtracadabraModal>
</template>

<script>
  import { ExtracadabraModal } from "@core/components/modals";

  export default {
    components: {
      ExtracadabraModal,
    },
    props: {
      opened: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["update:opened"],
    computed: {
      internalOpen: {
        get() {
          return this.opened;
        },
        set() {
          this.$emit("update:opened", false);
        },
      },
    },
  };
</script>

<style lang="scss">
  .cancel-ae-helper-modal {
    img {
      max-width: 275px;
    }
  }
</style>
